import { useEffect, useCallback, useState } from 'react';

const InactivityDetector = () => {
  // Define the inactivity timeout in milliseconds (2 hours)
  const inactivityTimeout = 2 * 60 * 60 * 1000; // 2 hours in milliseconds

  // Define a state to track the time of the last interaction
  const [lastInteractionTime, setLastInteractionTime] = useState(Date.now());

  // Function to refresh the page
  const refreshPage = useCallback(() => {
    window.location.reload(); // This will reload the page
  }, []);

  // Function to check user inactivity
  const checkInactivity = useCallback(() => {
    const now = Date.now();
    if (now - lastInteractionTime >= inactivityTimeout) {
      // The user has been inactive for too long, so refresh the page
      refreshPage();
    }
    setLastInteractionTime(now);
  }, [lastInteractionTime, inactivityTimeout, refreshPage]);

  // Add an event listener to detect page visibility
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // When the page becomes visible again, check for inactivity
        checkInactivity();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [checkInactivity]);

  // Initialize inactivity check when the component is mounted
  useEffect(() => {
    checkInactivity();
  }, [checkInactivity]);

  return null; // This component doesn't render anything in the UI
};

export default InactivityDetector;
